
import { View } from 'backbone';
import util from 'util/Util.js';
import nameTemplate from 'report/properties/main/chart-filter.ejs';
import Immutable    from 'immutable';


class MainChartFilterView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]':'updateCheckboxes'
        };

       if(this.model.get('setDynamicFilter') === undefined){
            this.model.set('setDynamicFilter',true, {silent:true})
        }

        if(this.model.get('respectDynamicFilter') === undefined){
            this.model.set('respectDynamicFilter',false, {silent:true})
        }

        if(this.model.get('additiveDynamicFilter') === undefined){
            this.model.set('additiveDynamicFilter',true, {silent:true})
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckboxes(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.checked;

        if (propName === 'additiveDynamicFilter') {
            propVal = (!propVal);
        }

        this.model.set( propName, propVal );
    }

    render() {
        
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.model.get('factoryKey') === 'control_filter_selector') {
            $('#setDynamic').closest('div.prop-detail').find('div.prop-header').remove();
            $('#setDynamic').remove();
        }

        let setDynamicFilter = util.isTrue(this.model.get('setDynamicFilter'));
        $(`input[name='setDynamicFilter']`).prop('checked', setDynamicFilter );

        let respectDynamicFilter = util.isTrue(this.model.get('respectDynamicFilter'));
        $(`input[name='respectDynamicFilter']`).prop('checked', respectDynamicFilter );

        let additiveDynamicFilter = util.isTrue(this.model.get('additiveDynamicFilter'));
        $(`input[name='additiveDynamicFilter']`).prop('checked', !additiveDynamicFilter );


        this.delegateEvents();
        return this;
    }

}

export default MainChartFilterView;
